import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React from 'react';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import addPhotoImage from '../../assets/images/self-inspect/camera.png';

const styles = theme => ({
  icon: {
    position: 'relative',
    cursor: 'pointer',
    height: 'auto',
    borderRadius: 5,
    // padding: '8px 16px 5px 10px', // accounting for offset absolute icon
    paddingRight: 5,
    color: 'var(--self-inspect-text-color)',
  },

  iconButton: {
    width: 40, // 75,
    marginTop: 5, // account for font space
  },
});

const CAMERA_ICON_FONT_SIZE = 50;

const SelfInspectCameraIcon = withStyles(styles)(
  ({ classes, className, style, imageInputId, size = CAMERA_ICON_FONT_SIZE }) => {
    return (
      <label
        //
        htmlFor={imageInputId}
        className={classnames(classes.icon, className)}
        style={style}
      >
        <div
          style={{
            position: 'relative',
            marginTop: 5, // account for icon font space
          }}
        >
          <PhotoCameraIcon
            style={{
              fontSize: size,
            }}
          />
          <AddCircleIcon
            style={{
              position: 'absolute',
              top: -size / 7,
              right: -size / 7,
              fontSize: size / 2,
              color: 'var(--jmi-green)',
              background: 'white',
              borderRadius: '50%',
            }}
          />
        </div>

        {/* <img
        //
        src={addPhotoImage}
        className={classes.iconButton}
        style={{
          width: 30,
        }}
      /> */}
      </label>
    );
  },
);

export default SelfInspectCameraIcon;
